import { Moon, Sun } from 'lucide-react';
import { memo } from 'react';

import { useTheme } from '@/app/providers/theme-provider';
import {
  type Resolved,
  ThemeToggler,
} from '@/components/animate-ui/primitives/effects/theme-toggler.tsx';

export const Header = memo(() => {
  const { theme, setTheme } = useTheme();

  return (
    <header className="flex items-center justify-between px-6 py-4 bg-background shadow-sm">
      {/*<SidebarTrigger />*/}
      <ThemeToggler setTheme={setTheme} theme={theme} resolvedTheme={theme as Resolved}>
        {({ effective, toggleTheme }) => {
          const nextTheme = effective === 'dark' ? 'light' : 'dark';
          return (
            <button className={'cursor-pointer'} onClick={() => toggleTheme(nextTheme)}>
              {effective === 'dark' ? <Moon /> : <Sun />}
            </button>
          );
        }}
      </ThemeToggler>
    </header>
  );
});
